import React from "react";

export const TrustBar = () => {
  return (
    <div id="trustbar">
      <div className="container">
        <ul>
          <li>
            <i className="fa fa-calendar"></i> Established 2018
          </li>
          <li>
            <i className="fa fa-map-marker"></i> Brisbane, Australia
          </li>
          <li>
            <i className="fa fa-flag"></i> Australian owned
          </li>
          <li>
            <i className="fa fa-check-circle"></i> ABN 68 629 081 349
          </li>
        </ul>
      </div>
    </div>
  );
};
